import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({
    submitNPSResponse: async (token, isAnon, rating, comment) => {
      const options = createRequestOptions({
        token,
        isAnon,
        rating,
        comment,
      });
      const result = await fetch(
        Config.serverUrl + "/SubmitNPSResponse",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    validateNPSToken: async (token) => {
      const options = createRequestOptions({
        token,
      });
      const result = await fetch(
        Config.serverUrl + "/ValidateNPSToken",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getNPSScoresAndResponses: async (appId) => {
      const options = createRequestOptions({
        appId,
      });
      const result = await fetch(
        Config.serverUrl + "/GetNPSScoresAndResponses",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/nps.js